var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 9,
    viewBox: "0 0 36 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5113 2.90454L0 8.87509H0.643724L1.9596 3.38964H1.97914L3.10077 8.87509H3.76345L7.61513 3.47314H7.63468L6.20095 8.87509H6.85475L8.3465 2.90454H7.38121L3.55914 8.26444L2.47659 2.90454H1.5113Z",
    fill: "#2EBDB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97247 4.5603L7.88992 8.87503H8.50404L9.58658 4.5603H8.97247Z",
    fill: "#2EBDB1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4696 4.55908L9.39946 8.87504H10.0142L10.4038 7.31125L11.4763 6.54154L12.8123 8.87504H13.4851L11.9637 6.22403L14.3432 4.5603H13.5242L10.5791 6.66709L10.5596 6.65063L11.0849 4.55908H10.4696Z",
    fill: "#2EBDB1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.705 4.56033L13.623 8.87507H14.2371L14.8027 6.61715C15.0076 5.806 15.5927 5.04544 16.6942 5.02837C16.8115 5.02837 16.9281 5.03691 17.0454 5.03691L17.1816 4.51036C17.0744 4.50183 16.9571 4.50183 16.85 4.50183C15.9528 4.4933 15.4168 4.93635 15.0266 5.55553H15.007L15.2605 4.56033H14.705Z",
    fill: "#2EBDB1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4437 6.12353C21.4437 5.06191 20.6246 4.4342 19.4545 4.4342C17.6601 4.4342 16.6462 5.78896 16.6462 7.20222C16.6462 8.2809 17.3581 9.00003 18.655 9.00003C20.5175 9.00003 21.4437 7.57884 21.4437 6.12353ZM20.8295 6.23262C20.8295 7.23574 20.1177 8.55697 18.7722 8.55697C17.7483 8.55697 17.2609 7.98838 17.2609 7.15225C17.2609 6.1406 18.0018 4.87787 19.3473 4.87787C20.3321 4.87787 20.8295 5.43001 20.8295 6.23262Z",
    fill: "#2EBDB1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3379 4.5573L27.7376 2.90393H21.7315L21.3341 4.55913H23.2611V4.55974H25.4091V4.55913L27.3379 4.5573Z",
    fill: "#2EBDB1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0699 5.3501L22.2189 8.8738H24.3638L25.2172 5.35132L25.2178 5.3501H23.0699Z",
    fill: "#2EBDB1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6825 5.35077L26.8345 8.87386H28.7651L29.6131 5.35077H27.6825ZM29.8073 4.5573L30.2083 2.90393H28.2777L27.8738 4.55974L29.8073 4.5573Z",
    fill: "#2EBDB1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0077 2.90393L29.5645 8.87386H31.4951L31.7977 7.63612L32.2365 7.30154L32.9188 8.87386H35.0152L33.7283 6.28197L36 4.53414H33.6892L32.2656 5.80479H32.246L32.9383 2.90393H31.0077Z",
    fill: "#2EBDB1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80213 0C10.0378 1.68567 10.9172 2.7089 12.7093 2.79361C11.0209 3.45788 9.2804 1.89531 9.80213 0Z",
    fill: "#2EBDB1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86529 0.296797C8.88542 0.292531 8.88779 0.306547 8.88898 0.321783C8.94642 1.39681 9.38702 2.21161 9.97034 2.76924C10.5466 3.32016 11.3377 3.77784 12.4446 3.75833C10.3742 4.60666 8.19965 2.56752 8.86529 0.296797Z",
    fill: "#2EBDB1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature20);
export default __webpack_public_path__ + "static/media/feature-20.78db33c96f48cce220e7fd35e4f3bf0c.svg";
export { ForwardRef as ReactComponent };